import { YouScreen } from "@components/Account/You";

export default YouScreen;

